import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faFacebook,
  faFacebookF,
  faFacebookSquare,
  faGooglePlusG,
  faGulp,
  faHotjar,
  faHtml5,
  faHubspot,
  faJs,
  faLinkedinIn,
  faMediumM,
  faNodeJs,
  faSass,
  faSimplybuilt,
  faTrello,
  faTwitter,
  faYoutube,
} from '@fortawesome/free-brands-svg-icons'
import {
  faAddressCard as farAddressCard,
  faCircle as farCircle,
  faClock as farClock,
  faComment as farComment,
  faCopy as farCopy,
  faDizzy as farDizzy,
  faEdit as farEdit,
  faFile as farFile,
  faFileArchive as farFileArchive,
  faFileAudio as farFileAudio,
  faFileCode as farFileCode,
  faFileImage as farFileImage,
  faFilePdf as farFilePdf,
  faFileVideo as farFileVideo,
  faHeart as farHeart,
  faImage as farImage,
  faLaughBeam as farLaughBeam,
  faLightbulb as farLightbulb,
  faMessage as farMessage,
  faObjectUngroup as farObjectUngroup,
  faPaperPlane as farPaperPlane,
  faQuestionCircle as farQuestionCircle,
  faSmileBeam as farSmileBeam,
  faStar as farStar,
} from '@fortawesome/free-regular-svg-icons'
import {
  faAddressCard,
  faAlignLeft,
  faAlignRight,
  faAngleLeft,
  faAngleRight,
  faAnglesLeft,
  faAnglesRight,
  faArchive,
  faArrowDown,
  faArrowLeft,
  faArrowRight,
  faArrowRightToBracket,
  faArrows,
  faArrowsAltV,
  faArrowUp,
  faAt,
  faBan,
  faBars,
  faBell,
  faBellSlash,
  faBolt,
  faBook,
  faBookOpen,
  faBox,
  faBoxOpen,
  faBug,
  faBuilding,
  faBuildingUser,
  faCalendarAlt,
  faCalendarCheck,
  faCalendarDay,
  faCamera,
  faCapsules,
  faCaretDown,
  faCaretRight,
  faCaretUp,
  faCartPlus,
  faChartColumn,
  faChartLine,
  faChartPie,
  faCheck,
  faCheckCircle,
  faCheckDouble,
  faCheckSquare,
  faChessRook,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faCircle,
  faCircleHalfStroke,
  faCircleNotch,
  faCity,
  faClock,
  faCloudDownloadAlt,
  faCode,
  faCodeBranch,
  faCog,
  faComments,
  faCompress,
  faCopy,
  faCross,
  faCrown,
  faDatabase,
  faDollarSign,
  faDownload,
  faEdit,
  faEllipsisH,
  faEllipsisV,
  faEllipsisVertical,
  faEnvelope,
  faEnvelopeOpen,
  faExchangeAlt,
  faExclamation,
  faExclamationCircle,
  faExclamationTriangle,
  faExpand,
  faExternalLinkAlt,
  faEye,
  faEyeSlash,
  faFile,
  faFileAlt,
  faFileArchive,
  faFileInvoice,
  faFilePdf,
  faFilter,
  faFire,
  faFlag,
  faFloppyDisk,
  faFolderOpen,
  faFolderPlus,
  faGaugeHigh,
  faGears,
  faGift,
  faGlobe,
  faGlobeAmericas,
  faHeart,
  faHome,
  faHouse,
  faIcons,
  faImage,
  faInfinity,
  faInfo,
  faInfoCircle,
  faKey,
  faLayerGroup,
  faLightbulb,
  faLink,
  faList,
  faListAlt,
  faListUl,
  faLocationArrow,
  faLock,
  faLongArrowAltDown,
  faLongArrowAltUp,
  faMagnifyingGlassArrowRight,
  faMap,
  faMapMarkerAlt,
  faMessage,
  faMicrochip,
  faMinus,
  faMobile,
  faMoon,
  faMusic,
  faObjectUngroup,
  faPalette,
  faPaperclip,
  faPaperPlane,
  faPencilAlt,
  faPercentage,
  faPhone,
  faPlay,
  faPlug,
  faPlus,
  faPlusSquare,
  faPoll,
  faPrint,
  faProjectDiagram,
  faPuzzlePiece,
  faQuestionCircle,
  faRectangleList,
  faRedo,
  faRedoAlt,
  faReply,
  faRocket,
  faSearch,
  faShapes,
  faShare,
  faShareAlt,
  faShieldAlt,
  faShieldHalved,
  faShoppingCart,
  faSignInAlt,
  faSlidersH,
  faSmileBeam,
  faSort,
  faSortAlphaDown,
  faSortAlphaUp,
  faSortAmountDown,
  faSortAmountUp,
  faSortNumericDown,
  faSortNumericUp,
  faSpinner,
  faStar,
  faStarHalfAlt,
  faStream,
  faSun,
  faSyncAlt,
  faTable,
  faTableCellsLarge,
  faTableList,
  faTag,
  faTags,
  faTasks,
  faTerminal,
  faTh,
  faThumbsUp,
  faThumbtack,
  faTimes,
  faTimesCircle,
  faTint,
  faTools,
  faTrash,
  faTrashAlt,
  faTrophy,
  faUser,
  faUserCircle,
  faUserFriends,
  faUserPlus,
  faUsers,
  faUsersViewfinder,
  faVideo,
  faWindowMaximize,
  faWrench,
} from '@fortawesome/free-solid-svg-icons'

library.add(
  faHouse,
  faUsers,
  faUser,
  faAddressCard,
  // Solid
  faBox,
  faSimplybuilt,
  faChartPie,
  faCopy,
  faChessRook,
  faSearch,
  faHome,
  faBell,
  faBellSlash,
  faPlay,
  faChevronRight,
  faChevronLeft,
  faChevronUp,
  faChevronDown,
  faExchangeAlt,
  faAngleRight,
  faAngleLeft,
  faEllipsisH,
  faCrown,
  faListAlt,
  faCheck,
  faBan,
  faStream,
  faArrowsAltV,
  faSort,
  faSortAlphaDown,
  faSortAlphaUp,
  faSortNumericDown,
  faSortNumericUp,
  faSortAmountDown,
  faSortAmountUp,
  faCheckCircle,
  faUserCircle,
  faQuestionCircle,
  faLock,
  faCircle,
  faHeart,
  faShareAlt,
  faCaretRight,
  faArrowDown,
  faArrowUp,
  faArrowLeft,
  faArrowRight,
  faPrint,
  faDollarSign,
  faLink,
  faPlus,
  faMinus,
  faUser,
  faPencilAlt,
  faCamera,
  faTimesCircle,
  faSignInAlt,
  faBook,
  faPuzzlePiece,
  faTrash,
  faAlignLeft,
  faAlignRight,
  faPlug,
  faTimes,
  faFilter,
  faExternalLinkAlt,
  faCartPlus,
  faShoppingCart,
  faStar,
  faStarHalfAlt,
  faArchive,
  faEnvelope,
  faClock,
  faStar,
  faReply,
  faLocationArrow,
  faCog,
  faPaperclip,
  faImage,
  faEllipsisV,
  faEnvelopeOpen,
  faRedo,
  faSlidersH,
  faTrashAlt,
  faFileArchive,
  faFilePdf,
  faFileAlt,
  faEye,
  faEyeSlash,
  faCaretUp,
  faCodeBranch,
  faExclamationTriangle,
  faListUl,
  faTh,
  faGift,
  faUsers,
  faGlobeAmericas,
  faGlobe,
  faPlusSquare,
  faCaretDown,
  faUserPlus,
  faCircleNotch,
  faExclamation,
  faThumbsUp,
  faComments,
  faPalette,
  faEdit,
  faTrashAlt,
  faShare,
  faCheckSquare,
  faTools,
  faCheckDouble,
  faSmileBeam,
  faPoll,
  faPercentage,
  faTags,
  faIcons,
  faList,
  faUserFriends,
  faExclamationCircle,
  faFolderPlus,
  faTag,
  faAt,
  faCalendarAlt,
  faCalendarCheck,
  faCalendarDay,
  faMapMarkerAlt,
  faCross,
  faFlag,
  faThumbtack,
  faTable,
  faChartLine,
  faShapes,
  faMap,
  faFire,
  faLayerGroup,
  faRocket,
  faWrench,
  faSun,
  faMoon,
  faInfoCircle,
  faSpinner,
  faCapsules,
  faTasks,
  faCloudDownloadAlt,
  faSyncAlt,
  faBug,
  faProjectDiagram,
  faBolt,
  faPaperPlane,
  faLongArrowAltDown,
  faLongArrowAltUp,
  faInfinity,
  faFile,
  faMusic,
  faMobile,
  faBookOpen,
  faTint,
  faTerminal,
  faBoxOpen,
  faMicrochip,
  faCity,
  faBuilding,
  faBuildingUser,
  faCodeBranch,
  faAnglesLeft,
  faAnglesRight,
  faEllipsisVertical,
  faFloppyDisk,
  faArrowRightToBracket,
  faDatabase,
  faMagnifyingGlassArrowRight,
  faWindowMaximize,
  faObjectUngroup,
  faExpand,
  faCompress,
  faBars,
  faShieldHalved,
  faShieldAlt,
  faTableList,
  faRectangleList,
  faChartColumn,
  faGaugeHigh,
  faCircleHalfStroke,
  faArrows,
  faDownload,
  faMessage,
  faUsersViewfinder,
  faFileInvoice,
  faGears,
  faTableCellsLarge,
  faLightbulb,
  // Brand
  faFacebook,
  faFacebookF,
  faFacebookSquare,
  faGulp,
  faNodeJs,
  faSass,
  faTwitter,
  faGooglePlusG,
  faLinkedinIn,
  faMediumM,
  faHotjar,
  faYoutube,
  faVideo,
  faInfo,
  faPhone,
  faTrello,
  faCode,
  faJs,
  faHtml5,
  faTrophy,
  faFolderOpen,
  faHubspot,
  // Regular
  farHeart,
  faKey,
  farLightbulb,
  farObjectUngroup,
  farPaperPlane,
  farStar,
  farImage,
  farFileArchive,
  farFilePdf,
  farFile,
  farAddressCard,
  farFileVideo,
  farFileAudio,
  farFileImage,
  farFileCode,
  farClock,
  farQuestionCircle,
  farDizzy,
  farLaughBeam,
  farSmileBeam,
  farCircle,
  farCopy,
  farComment,
  farEdit,
  faBuilding,
  faRedoAlt,
  farMessage
)
